<template>

    <section class="row p-4" id="contact">
      <div class="col-md-6 col-lg-3 col-sm-12 mt-4 text-center">
        <img src="@/assets/zingal-logo.png" alt="" width="250" />
      </div>
      <div class="col-md-3 mt-5 text-center">
        <h4>{{$t('footerTitles.awardsTitle')}}</h4>
        <hr />
        <ul>
          <li v-for="(filmname, i) in filmName" :key="i">
           <b> {{ filmname.filmName }} </b>
          </li>
          <li v-for="(reward, i) in rewards" :key="'A'+i">
            {{ reward.rewardsName }}
          </li>
        </ul>
      </div>
      <div class="col-md-6 col-lg-3 col-sm-12 mt-5 text-center">
        <h4>{{$t('footerTitles.otherProjectsTitle')}}</h4>
        <hr />
        <ul>
          <!-- Belgesel -->
          <a
            :href="belgesel.href"
            target="_blank"
            v-for="(belgesel, i) in belgeseller"
            :key="'B'+i"
          >
            <li>
              {{ belgesel.name }}
            </li>
          </a>
          <!-- Kısa Film -->
          <a
            :href="kisaFilm.href"
            target="_blank"
            v-for="(kisaFilm, i) in kisaFilm"
            :key="'C'+i"
          >
            <li>
              {{ kisaFilm.name }}
            </li>
          </a>
        </ul>
      </div>
      <div class="col-md-6 col-lg-3 col-sm-12 mt-5 text-center">
        <h4>{{$t('footerTitles.menusTitle')}}</h4>
        <hr />
        <ul>
          <a :href="item.hash"  v-for="(item, i) in menuItem" :key="'D'+i">
            <li>
              {{ item.name }}
            </li>
          </a>
        </ul>
      </div>

      <div class="hr mt-5 mb-5"></div>
      <div class="col-md-12 text-center">
        <!-- Sosyal Medya İkon -->
        <div class="col-md-12">
          <div class="social-media-wrapper">
            <a class="social-icon" href="https://www.facebook.com/izzet.arslan.96" target="_blank">
              <i class="fab fa-facebook-f"></i>
            </a>
          </div>
          <div class="social-media-wrapper">
            <a class="social-icon" href="https://www.instagram.com/arslanizzet/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
          <div class="social-media-wrapper">
            <a class="social-icon" href="mailto:arslnzzt@gmail.com" target="_blank">
              <i class="far fa-envelope"></i>
            </a>
          </div>
        </div>
        <h6 style="color:gray;" class="col-12 mt-3 text-center bottom">
          Copyright Zingal Son Kuşak © {{ date }}. <br> {{$t('copyright')}}
          | <i class="fas fa-laptop-code mt-1" style="font-size:20px;color:white;" ></i> by
          <a target="_blank" href="https://tr.linkedin.com/in/kaansen57">Kaan </a>
        </h6>
      </div>
      
    </section>

</template>

<script>
export default {
  data() {
    return {
      menuItem: [],
      belgeseller: [
        {
          href: "https://www.youtube.com/watch?v=f5xhxRg40Gk",
          name: "Zingal Son Kuşak",
        },
        { href: "#", name: "Karantina Adası" },
      ],
      kisaFilm: [
        {
          href: "https://www.youtube.com/watch?v=GoOMvvfiauI&t=2s",
          name: "İletişim Denemesi",
        },
      ],
      filmName: [
        {
          filmName:
            "Zingal Son Kuşak (Zingal The Last Generation) - 2019 - Belgesel, Süre : 00:20:00",
        },
      ],
      rewards: [
        {
          rewardsName:
            "11. Özgür Film Festivali, Kısa Film Yarışması, Belgesel Dalı, 3.lük Ödülü. 2019",
        },
        {
          rewardsName:
            "7. SETEM Akademi BAK Ödülleri, Ulusal Belgesel Dalı, En İyi Film Ödülü. 2019",
        },
        {
          rewardsName:
            "13. Mimarlık ve Kent Filmleri Festivali, Belgesel ve Canlandırma Filmleri Yarışması, Finalist. 2019",
        },
        {
          rewardsName:
            "2. İzmit Uluslararası Kısa Film Festivali, Uluslararası Belgesel Yarışması, Finalist. 2019",
        },
        {
          rewardsName:
            "8. Farklı Perspektifler Film Festivali, Bağlar Bölümü, Gösterim Seçkisi. 2020",
        },
      ],
      date: "",
    };
  },
  created() {
    this.date = new Date().getFullYear();
    if (localStorage.getItem("lang") === "en") {
      this.menuItem = this.$i18n.messages.en.menus;
    } else if (localStorage.getItem("lang") === "tr") {
      this.menuItem = this.$i18n.messages.tr.menus;
    }
  },
};
</script>

<style scoped>
.social-media {
  width: 50px;
  height: 50px;
  border: 1px solid white;
  border-radius: 150px;
}
* {
  font-family: "Cabin", sans-serif;
}
h3,h4 {
  color: #aeaeaf;
  text-transform: uppercase;
}
hr {
  background-color: #363636;
}
.row {
  background: #222;
}
label {
  color: white;
}
.card {
  border-radius: 0;
}
.hr {
  width: 85%;
  height: 2px;
  background: #646464;
  display: block;
  border-radius: 0 0 4px 4px;
  margin: auto;
  transition: all 0.3s ease-in-out;
}
a {
  text-decoration: none;
  color: #aeaeaf;
}
ul {
  padding: 0;
  margin: 0;
}
ul li {
  list-style-type: none;
  margin-top: 10px;
  color: #aeaeaf;
}
i {
  font-size: 25px;
  transition: all 0.5s ease-in-out;
}
.social-media-wrapper {
  display: inline-block;
  margin-right: 10px;
  width: 50px;
  height: 50px;
  border-radius: 150px;
  border: 1px solid white;
  transition: all 0.5s ease-in-out;
}
.social-media-wrapper:hover {
  background-color: white;
  transition: all 0.5s ease-in-out;
}
.social-media-wrapper:hover a > i {
  font-size: 25px;
  color: #333;
  transition: all 0.5s ease-in-out;
}
.social-icon {
  position: relative;
  top: 10px;
}
</style>